<template>
  <pt-batch-monitoring class="pt-batch-monitoring__withData" :data="batchMessage" :loading="loading" @getCurrentBatch="getCurrentBatch"
                       @getExceptionExport="getExceptionExport"></pt-batch-monitoring>
</template>

<script>
import PtBatchMonitoring from './index'
export default {
  name: 'pt-batch-monitoring__withData',
  components: {
    'pt-batch-monitoring': PtBatchMonitoring
  },
  data () {
    return {
      batchMessage: {},
      loading: false,
      exportLoading: false
    }
  },
  methods: {
    getCurrentBatch () {
      // let
      this.loading = true
      this.$store.dispatch('getCurrentBatch').then(res => {
        this.batchMessage = res
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取跑批监测数据失败')
      })
    },
    getExceptionExport (val) {
      let data = {
        ...val,
        pageable: {}
      }
      this.exportLoading = true
      this.$store.dispatch('getExceptionExport', data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.$message.error(err || '导出列表失败')
        this.exportLoading = false
      })
    }
  },
  created () {
    // this.getCurrentBatch()
  }
}
</script>
